import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {cartItemInterface} from "../../../shoppingCart/cartItemInterface";
import {LOOK_OVERLAYS} from "../../core/constants";
import {setLookOverlayOpened, setLookStylePopup} from "../../../../actions/lookFunctions";
import {isInStock} from "../../lookNavigation/lookFunctions2";
import LookListMainFeatureActionsMoreButton from "./lookListMainFeatureActionsMoreButton";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const LookListMainFeatureActions = (props) => {

  const {cartItem, intl, setLookOverlayOpened, setLookStylePopup} = props;

  const deleteButtonClick = () => {
    const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemRemove + featureLabel);

    const notMatchingFeatures = [cartItem.cartFeature];
    setLookOverlayOpened(LOOK_OVERLAYS.styleRemove);
    setLookStylePopup({
      notMatchingFeatures
    });
    console.log("cartItem", cartItem);
  }

  return (
    <div className="ll-feature__actions">
      {isInStock(cartItem.cartFeature) || cartItem.relatedProductParent ? (
        <IconButton aria-label={intl.formatMessage({id:"iconButton.delete"})}
                    className="look-icon look-icon--small"
                    onClick={deleteButtonClick}>
          <DeleteForeverIcon/>
        </IconButton>
      ) : (
        <LookListMainFeatureActionsMoreButton cartItem={cartItem}/>
      )}
    </div>
  )
};

LookListMainFeatureActions.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired
}

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookStylePopup,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookListMainFeatureActions)
)
